var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"with-padding"},[(Array.isArray(_vm.value))?_c('span',[_vm._v(_vm._s(_vm.value.map(a => a.brezel_name).join(', ').substring(0, 50)))]):(_vm.value.brezel_name)?_c('span',[_vm._v(_vm._s(_vm.value.brezel_name))]):_c('span',[_vm._v(_vm._s(_vm.value))])]):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }